import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { StyledEngineProvider } from '@mui/material/styles';
import App from './App';
import { AuthContextProvider } from './modules/Core/store/auth-context';
// import reportWebVitals from './reportWebVitals';

const container = document.querySelector('#root');
const root = createRoot(container);
root.render(
  <AuthContextProvider>
    <StyledEngineProvider injectFirst>
      <App />
    </StyledEngineProvider>
  </AuthContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
